module.exports = {"city":"Stadt","enter_city":"Geben Sie die Stadt ein","select_city":"Stadt auswählen"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/de/city.json
// module id = 477
// module chunks = 248 1701